<template>
  <v-card class="overflow-hidden">
    <v-app-bar
      fixed
      color="#fcb69f"
      dark
      dense
      src="https://picsum.photos/1920/1080?random"
      v-if="displayMenu"
      height="69vh"
    >
      <template v-slot:img="{ props }">
        <v-img
          v-bind="props"
          gradient="to top right, rgba(19,84,122,.5), rgba(128,208,199,.8)"
        ></v-img>
      </template>

      <v-app-bar-nav-icon
        @click="drawer = true"
        class="hidden-md hidden-lg"
      ></v-app-bar-nav-icon>

      <v-app-bar-title>
        <a class="navbar-brand logo" href="/">
          <img src="/img/logo_Kira-RH.png" alt="" width="100" height="30" />
        </a>
      </v-app-bar-title>

      <v-spacer></v-spacer>
      <v-btn
        text
        class="hidden-sm-and-down"
        to="/"
        v-if="menuType === 2 || menuType === 1"
      >
        <v-icon left> mdi-folder-home-outline </v-icon>
        Accueil
      </v-btn>
      <!-- COMPANY -->
      <v-btn
        text
        class="hidden-sm-and-down"
        to="/company/cv-theque"
        v-if="menuType === 2"
      >
        <v-icon left> mdi-badge-account-outline </v-icon>
        CVthèque
      </v-btn>

      <v-btn
        text
        class="hidden-sm-and-down"
        to="/company/offers"
        v-if="menuType === 2"
      >
        <v-icon left> mdi-folder-table-outline </v-icon>
        Mes offres d'emploi
      </v-btn>

      <v-btn
        to="/company/my-account"
        text
        class="hidden-sm-and-down"
        v-if="menuType === 2"
      >
        <v-icon left>mdi-domain</v-icon>
        Mon espace employeur
      </v-btn>

      <!-- CANDIDATE -->
      <v-btn
        text
        class="hidden-sm-and-down"
        to="/candidate/offers"
        v-if="menuType === 1"
      >
        <v-icon left> mdi-badge-account-outline </v-icon>
        Offres
      </v-btn>

      <v-btn
        to="/candidate/cv"
        text
        class="hidden-sm-and-down"
        v-if="menuType === 1"
      >
        <v-icon left> mdi-file-account </v-icon>
        Mon espace CVs
      </v-btn>

      <v-btn
        text
        class="hidden-sm-and-down"
        to="/candidate/my-job-research"
        v-if="menuType === 1"
      >
        <v-icon left> mdi-folder-table-outline </v-icon>
        Mes recherches
      </v-btn>

      <v-btn
        to="/candidate/my-account"
        text
        class="hidden-sm-and-down"
        v-if="menuType === 1"
      >
        <v-icon left>mdi-account-cog</v-icon>
        Mon compte
      </v-btn>

      <v-btn class="hidden-sm-and-down" text to="/logout">
        <v-icon left>mdi-account-convert-outline</v-icon>
        Déconnexion
      </v-btn>
    </v-app-bar>
    <v-navigation-drawer v-model="drawer" absolute temporary>
      <v-list nav dense>
        <!-- RESPONSIVE DRAWER FOR COMPANy -->
        <v-list-item-group
          v-if="menuType === 2"
          active-class="deep-purple--text text--accent-4"
        >
          <v-list-item to="/candidate/offers">
            <v-list-item-icon>
              <v-icon>mdi-badge-account-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title>CVtèque</v-list-item-title>
          </v-list-item>

          <v-list-item to="/company/offers">
            <v-list-item-icon>
              <v-icon>mdi-folder-table-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Mes offres d'emploi</v-list-item-title>
          </v-list-item>

          <v-list-item to="/company/my-account">
            <v-list-item-icon>
              <v-icon>mdi-domain</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Mon espace employeur</v-list-item-title>
          </v-list-item>

          <v-list-item to="/logout">
            <v-list-item-icon>
              <v-icon>mdi-account-convert-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Déconnexion</v-list-item-title>
          </v-list-item>
        </v-list-item-group>

        <!-- RESPONSIVE DRAWER FOR CANDIDATE -->
        <v-list-item-group
          v-if="menuType === 1"
          active-class="deep-purple--text text--accent-4"
        >
          <v-list-item to="/candidate/offers">
            <v-list-item-icon>
              <v-icon>mdi-badge-account-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Offres</v-list-item-title>
          </v-list-item>

          <v-list-item to="/candidate/cv">
            <v-list-item-icon>
              <v-icon>mdi-file-account</v-icon>
            </v-list-item-icon>
            <v-list-item-title> Mon espace CVs</v-list-item-title>
          </v-list-item>

          <v-list-item to="/candidate/my-job-research">
            <v-list-item-icon>
              <v-icon>mdi-folder-table-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Mes recherches</v-list-item-title>
          </v-list-item>

          <v-list-item to="/candidate/my-account">
            <v-list-item-icon>
              <v-icon>mdi-account-cog</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Mon compte</v-list-item-title>
          </v-list-item>
          <v-list-item to="/logout">
            <v-list-item-icon>
              <v-icon>mdi-account-convert-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Déconnexion</v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
    <router-view />
    <Footer v-if="displayMenu" />
  </v-card>
</template>

<script>
import Footer from "@/components/common/Footer";
export default {
  name: "AppMenu",
  components: { Footer },
  data() {
    return {
      menuType: null,
      drawer: false,
      displayMenu: true,
    };
  },
  mounted() {
    const currentUser = JSON.parse(localStorage.getItem("currentUser"));
    if (currentUser === null) {
      this.displayMenu = false;
    } else {
      this.displayMenu = true;
      if (currentUser.roles.includes("ROLE_SEEKER")) {
        this.menuType = 1;
      } else if (currentUser.roles.includes("ROLE_COMPANY")) {
        this.menuType = 2;
      } else {
        this.$router.push("/logout");
      }
    }
  },
};
</script>

<style scoped></style>
